import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../config";

const apiUrl = config.apiUrl;

const CreateLive = ({ onLiveCreated }) => {
  const [formData, setFormData] = useState({
    video_url: "",
    video: null,    
    seenPeople: "",
    offerHeadline: "",
    offerParagraph: "",
    offerButton: "",
    offerTime: "",
    redirectPage: "",
    pixelId: "",
    bonus_links: [
      {
        type: "gift",
        title: "",
        button_text: "",
        link: "",
        description: "",
        show_time: 0,
        duration: 60,
        order: 0,
        is_active: 1
      }
    ]
  });

  const [uploadVideo, setUploadVideo] = useState(false);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleBonusLinkChange = (index, field, value) => {
    const updatedBonusLinks = [...formData.bonus_links];
    updatedBonusLinks[index][field] = value;
    setFormData((prev) => ({ ...prev, bonus_links: updatedBonusLinks }));
  };

  const addBonusLink = () => {
    setFormData((prev) => ({
      ...prev,
      bonus_links: [
        ...prev.bonus_links,
        {
          type: "gift",
          title: "",
          button_text: "",
          link: "",
          description: "",
          show_time: 0,
          duration: 60,
          order: prev.bonus_links.length,
          is_active: 1
        }
      ]
    }));
  };

  const removeBonusLink = (index) => {
    if (formData.bonus_links.length > 1) {
      const updatedBonusLinks = [...formData.bonus_links];
      updatedBonusLinks.splice(index, 1);
      setFormData((prev) => ({ ...prev, bonus_links: updatedBonusLinks }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
  
    const data = new FormData();
  
    if (uploadVideo && formData.video) {
      data.append("video", formData.video);
    } else if (!uploadVideo && formData.video_url) {
      data.append("video_url", formData.video_url);
    }
  
    data.append("seenPeople", formData.seenPeople);
    data.append("offerHeadline", formData.offerHeadline);
    data.append("offerParagraph", formData.offerParagraph);
    data.append("offerButton", formData.offerButton);
    data.append("offerTime", formData.offerTime);
    data.append("redirectPage", formData.redirectPage);
    data.append("pixelId", formData.pixelId || "");

    // Bonus links যোগ করা
    formData.bonus_links.forEach((link, index) => {
      data.append(`bonus_links[${index}][type]`, link.type);
      data.append(`bonus_links[${index}][title]`, link.title);
      data.append(`bonus_links[${index}][button_text]`, link.button_text);
      data.append(`bonus_links[${index}][link]`, link.link);
      data.append(`bonus_links[${index}][description]`, link.description || "");
      data.append(`bonus_links[${index}][show_time]`, link.show_time);
      data.append(`bonus_links[${index}][duration]`, link.duration);
      data.append(`bonus_links[${index}][order]`, link.order);
      data.append(`bonus_links[${index}][is_active]`, link.is_active);
    });
  
    try {
      const response = await axios.post(`${apiUrl}/lives`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Live Section Created Successfully!");
      onLiveCreated();
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred while creating the live section");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-gray-800 border-b pb-2">Create New Live Section</h2>
      
      {error && (
        <div className="mb-4 p-3 bg-red-100 border-l-4 border-red-500 text-red-700">
          <p>{error}</p>
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Video Source Selection */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={uploadVideo}
              onChange={(e) => {
                setUploadVideo(e.target.checked);
                setFormData((prev) => ({
                  ...prev,
                  video: e.target.checked ? null : prev.video,
                  video_url: e.target.checked ? "" : prev.video_url,
                }));
              }}
              className="form-checkbox h-5 w-5 text-blue-600"
            />
            <span className="text-gray-700 font-medium">Upload video file instead of using a link</span>
          </label>
        </div>

        {/* Video Source Input */}
        {uploadVideo ? (
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Upload Video File</label>
            <div className="mt-1 flex items-center">
              <input
                type="file"
                name="video"
                onChange={handleChange}
                accept="video/*"
                className="block w-full text-sm text-gray-500
                  file:mr-4 file:py-2 file:px-4
                  file:rounded-md file:border-0
                  file:text-sm file:font-semibold
                  file:bg-blue-50 file:text-blue-700
                  hover:file:bg-blue-100"
              />
            </div>
            <p className="mt-1 text-sm text-gray-500">MP4, MOV, or AVI. Max 128MB.</p>
          </div>
        ) : (
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Video URL</label>
            <input
              type="text"
              name="video_url"
              value={formData.video_url}
              onChange={handleChange}
              placeholder="https://example.com/video.mp4"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
              disabled={uploadVideo}
            />
            <p className="mt-1 text-sm text-gray-500">Direct link to your video file</p>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Viewer Count */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Viewer Count</label>
            <input
              type="number"
              name="seenPeople"
              value={formData.seenPeople}
              onChange={handleChange}
              placeholder="e.g. 1250"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
            />
            <p className="mt-1 text-sm text-gray-500">Number of people watching</p>
          </div>

          {/* Offer Time */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Offer Timer (seconds)</label>
            <input
              type="number"
              name="offerTime"
              value={formData.offerTime}
              onChange={handleChange}
              placeholder="e.g. 3600"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
            />
            <p className="mt-1 text-sm text-gray-500">Time remaining for offer in seconds</p>
          </div>
        </div>

        {/* Offer Headline */}
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Offer Headline</label>
          <input
            type="text"
            name="offerHeadline"
            value={formData.offerHeadline}
            onChange={handleChange}
            placeholder="Special Limited Time Offer!"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
          />
          <p className="mt-1 text-sm text-gray-500">Main attention-grabbing text</p>
        </div>

        {/* Offer Description */}
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Offer Description</label>
          <textarea
            name="offerParagraph"
            value={formData.offerParagraph}
            onChange={handleChange}
            rows={3}
            placeholder="Describe your offer in detail..."
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
          ></textarea>
          <p className="mt-1 text-sm text-gray-500">Details about your special offer</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Button Text */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Button Text</label>
            <input
              type="text"
              name="offerButton"
              value={formData.offerButton}
              onChange={handleChange}
              placeholder="e.g. Claim Offer Now"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
            />
            <p className="mt-1 text-sm text-gray-500">Text for the call-to-action button</p>
          </div>

          {/* Redirect Page */}
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Redirect URL</label>
            <input
              type="text"
              name="redirectPage"
              value={formData.redirectPage}
              onChange={handleChange}
              placeholder="https://example.com/offer"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
            />
            <p className="mt-1 text-sm text-gray-500">Where users go after clicking</p>
          </div>
        </div>

        {/* Facebook Pixel */}
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Facebook Pixel ID (Optional)</label>
          <input
            type="text"
            name="pixelId"
            value={formData.pixelId}
            onChange={handleChange}
            placeholder="e.g. 123456789012345"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
          />
          <p className="mt-1 text-sm text-gray-500">For tracking conversions</p>
        </div>

        {/* Bonus Links Section */}
        <div className="border-t pt-6 mt-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-medium text-gray-800">Bonus Links</h3>
            <button
              type="button"
              onClick={addBonusLink}
              className="px-3 py-1 bg-green-600 text-white rounded-md text-sm hover:bg-green-700"
            >
              + Add Link
            </button>
          </div>

          {formData.bonus_links.map((link, index) => (
            <div key={index} className="bg-gray-50 p-4 rounded-lg mb-4 border">
              <div className="flex justify-between items-center mb-3">
                <h4 className="font-medium text-gray-700">Bonus Link #{index + 1}</h4>
                {formData.bonus_links.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeBonusLink(index)}
                    className="px-2 py-1 bg-red-600 text-white rounded-md text-xs hover:bg-red-700"
                  >
                    Remove
                  </button>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">Type</label>
                  <select
                    value={link.type}
                    onChange={(e) => handleBonusLinkChange(index, 'type', e.target.value)}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
                  >
                    <option value="gift">Free Gift</option>
                    <option value="download">Download Link</option>
                    <option value="secret_group">Secret Group Link</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">Title</label>
                  <input
                    type="text"
                    value={link.title}
                    onChange={(e) => handleBonusLinkChange(index, 'title', e.target.value)}
                    placeholder="e.g. Free Ebook"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">Button Text</label>
                  <input
                    type="text"
                    value={link.button_text}
                    onChange={(e) => handleBonusLinkChange(index, 'button_text', e.target.value)}
                    placeholder="e.g. Download Now"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
                  />
                </div>

                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">Link URL</label>
                  <input
                    type="text"
                    value={link.link}
                    onChange={(e) => handleBonusLinkChange(index, 'link', e.target.value)}
                    placeholder="https://example.com/download"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">Show Time (seconds)</label>
                  <input
                    type="number"
                    value={link.show_time}
                    onChange={(e) => handleBonusLinkChange(index, 'show_time', parseInt(e.target.value) || 0)}
                    placeholder="e.g. 300"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
                  />
                  <p className="mt-1 text-xs text-gray-500">When to show this link (in seconds)</p>
                </div>

                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">Duration (seconds)</label>
                  <input
                    type="number"
                    value={link.duration}
                    onChange={(e) => handleBonusLinkChange(index, 'duration', parseInt(e.target.value) || 60)}
                    placeholder="e.g. 60"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
                  />
                  <p className="mt-1 text-xs text-gray-500">How long to show this link</p>
                </div>
              </div>

              <div className="space-y-1 mb-3">
                <label className="block text-sm font-medium text-gray-700">Description (Optional)</label>
                <textarea
                  value={link.description}
                  onChange={(e) => handleBonusLinkChange(index, 'description', e.target.value)}
                  rows={2}
                  placeholder="Short description of this bonus..."
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
                ></textarea>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-1">
                  <label className="block text-sm font-medium text-gray-700">Order</label>
                  <input
                    type="number"
                    value={link.order}
                    onChange={(e) => handleBonusLinkChange(index, 'order', parseInt(e.target.value) || 0)}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border"
                  />
                </div>

                <div className="space-y-1 flex items-center">
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={link.is_active}
                      onChange={(e) => handleBonusLinkChange(index, 'is_active', e.target.checked)}
                      className="form-checkbox h-5 w-5 text-blue-600"
                    />
                    <span className="text-sm font-medium text-gray-700">Active</span>
                  </label>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="pt-4">
          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
          >
            {isSubmitting ? (
              <>
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Creating...
              </>
            ) : 'Create Live Section'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateLive;